import React, { useCallback, useEffect, useState } from 'react'

import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

type InputFacebookUrlProps = {
  checkboxName: string
  inputName: string
  checkboxLabel: string
  inputLabel?: string
  disabled?: boolean
  icon: React.ElementType<React.SVGProps<SVGSVGElement>>
}

const InputFacebookUrl: React.FC<InputFacebookUrlProps> = ({
  checkboxName,
  inputName,
  checkboxLabel,
  inputLabel,
  disabled,
  icon: Icon,
}) => {
  const { register, errors, watch, setValue } = useFormContext()

  const checked = watch(checkboxName)

  const isError = !!errors[inputName]
  const helperText = errors[inputName]?.message

  const handleCheckboxChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, state: boolean) => {
      setValue(checkboxName, state)
    },
    [setValue, checkboxName],
  )

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={1} sm={2} md={1} justify="center">
        <Icon />
      </Grid>
      <Grid item xs={11} sm={10} md={11}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleCheckboxChange}
              name={checkboxName}
              inputRef={register}
              disabled={disabled}
            />
          }
          label={checkboxLabel}
        />
        {checked && (
          <TextField
            variant="outlined"
            label={inputLabel}
            id={name}
            name={inputName}
            inputRef={register}
            error={isError}
            helperText={helperText}
            disabled={disabled}
            fullWidth
          />
        )}
      </Grid>
    </Grid>
  )
}

export default InputFacebookUrl
